function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5117,4.97379915e-14 C49.2461,4.97379915e-14 54,4.7539 54,10.4883 L54,10.4883 L54,24.1299 L24.6716,53.392 L0.5859,29.3284 L29.8701,4.97379915e-14 Z M43.5117,2 L30.6982,2 L3.4362,29.3284 L24.6716,50.5859 L52,23.3018 L52,10.4883 C52,5.8564 48.1436,2 43.5117,2 L43.5117,2 Z M43.5,6 C45.9814,6 48,8.0186 48,10.5 C48,12.9814 45.9814,15 43.5,15 C41.0186,15 39,12.9814 39,10.5 C39,8.0186 41.0186,6 43.5,6 Z M43.5,8 C42.1216,8 41,9.1216 41,10.5 C41,11.8784 42.1216,13 43.5,13 C44.8784,13 46,11.8784 46,10.5 C46,9.1216 44.8784,8 43.5,8 Z",
  id: "Combined-Shape"
});

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atom/Icon/System/tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.2e22f1f5.svg";
export { ForwardRef as ReactComponent };